//import components

import Datepicker from 'vuejs-datepicker';
import PlannerWidget from './components/planner-widget.vue';
import FavouriteWidget from './components/favourite-widget.vue';

//register globally to allow access to child components
Vue.component('Datepicker', Datepicker);
Vue.component('PlannerWidget', PlannerWidget);
Vue.component('FavouriteWidget', FavouriteWidget);

import Recipe from './components/recipe.vue';

window.vueRecipe = new Vue({

    name: 'recipe-page',

    el: '#recipe-app',

    components: {

        Recipe

    },

});